import {useContext} from "react";
import {UserContext} from "../context/UserContext";
import {UserInfo} from "../types/types";

export function useUserInfo(): { userInfo: UserInfo, updateUserInfo: (userInfo: Partial<UserInfo>) => void, update1ApiMode: (mode: "prod" | "dev" | 'dev2') => void, getApi: () => string, theme: "light" | "dark", handleThemeChange: (theme: "light" | "dark") => void, isMobile: boolean } {
    const userInfoHelpers = useContext(UserContext);
    return userInfoHelpers;
}
